import React, { useState } from 'react'
import { Typography } from '../../../../../components/common'
import { CheckIcon } from '../../../../../theme/icons2'
import { ClientWiseTable } from './ClientWise'
import { UserWiseTable } from './UserWise'
import { CheckUserRole } from '../../../../../components/common/CheckUserRole'

export const DetailedOverview = ({ onCloseDialogue, startDate }) => {
    const { isAssociate } = CheckUserRole();
    const [chips, setchips] = useState([
        { id: 0, name: 'Client wise', checked: true },
        (!isAssociate && { id: 1, name: 'User wise', checked: false }),
    ]?.filter(e => e))

    const handleClickChip = (item) => {
        const newChips = [...chips]?.map(chip => ({
            ...chip, checked: item?.id === chip?.id
        }))
        setchips(newChips)
    }
    
    const tableList = {
        ...{ 0: <ClientWiseTable startDate={startDate} onCloseDialogue={onCloseDialogue} /> },
        ...(!isAssociate && { 1: <UserWiseTable startDate={startDate} onCloseDialogue={onCloseDialogue} /> })
    }

    const { id: activeIdTable } = (chips?.length && chips?.find(chip => chip.checked)) || {}

    return (
        <div>
            <div className='flex gap-4 my-2'>
                {!!chips?.length && chips?.map(chip =>
                    <div key={chip?.id} role="button" onClick={() => handleClickChip(chip)}
                        className={`border  border-secondary-400 rounded-full w-32 m-0 px-1.5 py-1 flex justify-center  items-center gap-1 ${chip?.checked ? 'bg-primary-50 text-primary-400' : 'bg-secondary-50 text-secondary-400'}`} >
                        {chip?.checked && <CheckIcon />}   <Typography variant="base" text={chip?.name} />
                    </div>)}
            </div>
            <div>
                {tableList?.[activeIdTable] || ""}
            </div>
        </div>
    )
}
